module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_c('i', {
    staticClass: "fa fa-fire text-success"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.person.editMode),
      expression: "!person.editMode"
    }]
  }, [_vm._v("创建教学团队")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.person.editMode),
      expression: "person.editMode"
    }]
  }, [_vm._v("编辑教学团队")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('CreateSaveButton', {
    attrs: {
      "entity": _vm.person,
      "callback": _vm.save
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 m-t-md"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label compulsory"
  }, [_vm._v("名字")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.name),
      expression: "person.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.person.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.person, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.type),
      expression: "person.type"
    }],
    staticClass: "form-control m-b",
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.person, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.person.TypeList), function(type) {
    return _c('option', {
      domProps: {
        "value": type.value
      }
    }, [_vm._v(_vm._s(type.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clear"
  }, [_c('img', {
    staticClass: "thumb-lg pull-left m-r-md"
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label compulsory"
  }, [_vm._v("图片(建议尺寸400*400)")]), _vm._v(" "), _c('div', [_c('NbTank', {
    attrs: {
      "tank": _vm.person.image
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label compulsory"
  }, [_vm._v("头衔")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.title),
      expression: "person.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.person.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.person, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.phone),
      expression: "person.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.person.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.person, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("电子邮件")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.email),
      expression: "person.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.person.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.person, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("办公地点")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.person.office),
      expression: "person.office"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.person.office)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.person, "office", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label compulsory"
  }, [_vm._v("简介")]), _vm._v(" "), _c('div', [_c('NbEditor', {
    model: {
      value: (_vm.person.description),
      callback: function($$v) {
        _vm.$set(_vm.person, "description", $$v)
      },
      expression: "person.description"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 m-t-md"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.person.errorMessage),
      expression: "person.errorMessage"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.person.errorMessage) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('CreateSaveButton', {
    attrs: {
      "entity": _vm.person,
      "callback": _vm.save
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v("类别")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-56249a57"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/person/Create.vue
// module id = 985
// module chunks = 1